var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 48 48",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43,33H42V11h1a3,3,0,0,0,0-6H30.387l.561-1.684A1,1,0,0,0,30,2H27a1,1,0,0,0-.948.684L25.28,5H22.72l-.772-2.316A1,1,0,0,0,21,2H18a1,1,0,0,0-.948,1.316L17.613,5H5a3,3,0,0,0,0,6H6V33H5a3,3,0,0,0,0,6h5.484l-2.4,5.606A1,1,0,0,0,9,46h3a1,1,0,0,0,.919-.606L15.659,39H32.341l2.74,6.394A1,1,0,0,0,36,46h3a1,1,0,0,0,.919-1.394L37.516,39H43a3,3,0,0,0,0-6ZM27.721,4h.891l-.333,1h-.891ZM20.279,4l.333,1h-.891l-.333-1ZM5,9A1,1,0,0,1,5,7H43a1,1,0,0,1,0,2Zm31,9a1,1,0,0,0,1-1V11h3V33H8V11H35v6A1,1,0,0,0,36,18ZM11.341,44h-.824l2.142-5h.824Zm25.318,0-2.142-5h.824l2.142,5ZM43,37H5a1,1,0,0,1,0-2H43a1,1,0,0,1,0,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteboard);
export default __webpack_public_path__ + "static/media/whiteboard.d3bfcec806c348b2e51b9064ca77d263.svg";
export { ForwardRef as ReactComponent };